<template>
  <div>
    <div class="login" >
     <div style="padding:20px 20px;
    text-align: left;
    display: flex;
    align-items: center;font-weight:bold;"  @click='goback'>
        <mu-icon value='arrow_back'></mu-icon>
        {{this.$route.params.symbolName}}
        </div>
      <dl class="user-title">
       
        <dd >设置密码</dd>

      </dl>


      <div class="user-form">
<!--          <mu-text-field full-width type='text' v-model="idnumber" placeholder="请输入身份证号码"> </mu-text-field> -->
         <mu-text-field full-width type='text' v-model="name" placeholder="请输入真实姓名"> </mu-text-field>
       
         <mu-text-field full-width type='password' v-model="password1" placeholder="请输入密码"> </mu-text-field>
         <mu-text-field full-width type='password' v-model="password2" placeholder="请再次输入密码"> </mu-text-field>
       <!--   <mu-text-field full-width type='text' v-model="icode" placeholder="请输入邀请码"> </mu-text-field> -->
         <div style="width: 100%;align-items: center;
    display: flex;
    text-align: left;">
             <mu-checkbox v-model="acceptXiyi" label="我同意"></mu-checkbox><span>《用户协议》</span>
         </div>
         
          <br>
          <mu-button color="primary" :disabled="!canRegister" full-width @click="submit">注册</mu-button>
      </div>
      
    </div>
  </div>
</template>

<script>
import Api from '@/api'
import Util from '@/utils'
export default {
    data(){
      return {
          acceptXiyi:false,
          password1:"",
          password2:"",
          name:'',
          idnumber:'',
          icode:'',
          username:'',
      }
    },
    computed:{
         canRegister(){
             if(this.password1.length<6){
                 return false;
             }
            return this.acceptXiyi && this.password1==this.password2
         }
    },
    methods:{
        toLogin(){
            this.$router.push("/login")
        },
         goback(){
          this.$router.go(-1);
        },
         submit(){
            Api.register(this.$store.state.phone,this.password1,this.$store.state.vcode,this.name,this.icode,this.idnumber).then((res)=>{
                this.$indicator.close()
        if (!res.data.hasOwnProperty("error")) {
               this.$store.state.user=res.data.user;
               window.token=res.data.token;
               Util.setToken(window.token);
               this.$toast("注册成功")
          this.$router.push('/')
        }
        else {
          this.$toast(res.data.error)
        }
            })
            this.$toast("注册成功")
            this.$router.push("/")
        }
    },
};
</script>

<style scoped>
  .user-top{
      display: flex;
      justify-content: flex-end;
      padding-top:10px;
     
  }
  .user-title{
      padding:40px 20px;
      width: 50%;
      text-align: left;
      font-size: 2rem;
  }
  .user-form{
      display: flex;
       padding: 20px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
  }
  .myinput {
      height:50px;
      width: 80%;
      border: gray;
  }
</style>>

</style>


// WEBPACK FOOTER //
// src/pages/PasswordSet.vue